import { I18n } from 'src/translations/i18n';
import { toastr } from 'react-redux-toastr';
import toastrError from 'src/helpers/toastr/toastrError';
import { wtsApi } from 'src/api';
export var PlannerPolicyActions;
(function (PlannerPolicyActions) {
    PlannerPolicyActions["GET_ALL_PLANNER_POLICIES_REQUEST"] = "GET_ALL_PLANNER_POLICIES_REQUEST";
    PlannerPolicyActions["GET_ALL_PLANNER_POLICIES_SUCCESS"] = "GET_ALL_PLANNER_POLICIES_SUCCESS";
    PlannerPolicyActions["GET_ALL_PLANNER_POLICIES_FAIL"] = "GET_ALL_PLANNER_POLICIES_FAIL";
    PlannerPolicyActions["CREATE_UPDATE_PLANNER_POLICY_SUCCESS"] = "CREATE_UPDATE_PLANNER_POLICY_SUCCESS";
    PlannerPolicyActions["DELETE_PLANNER_POLICY_SUCCESS"] = "DELETE_PLANNER_POLICY_SUCCESS";
    PlannerPolicyActions["GET_AGGREGATION_OPERATIONS_REQUEST"] = "GET_AGGREGATION_OPERATIONS_REQUEST";
    PlannerPolicyActions["GET_AGGREGATION_OPERATIONS_SUCCESS"] = "GET_AGGREGATION_OPERATIONS_SUCCESS";
    PlannerPolicyActions["GET_AGGREGATION_OPERATIONS_FAIL"] = "GET_AGGREGATION_OPERATIONS_FAIL";
    PlannerPolicyActions["GET_AGGREGATION_TARGETS_REQUEST"] = "GET_AGGREGATION_TARGETS_REQUEST";
    PlannerPolicyActions["GET_AGGREGATION_TARGETS_SUCCESS"] = "GET_AGGREGATION_TARGETS_SUCCESS";
    PlannerPolicyActions["GET_AGGREGATION_TARGETS_FAIL"] = "GET_AGGREGATION_TARGETS_FAIL";
    PlannerPolicyActions["GET_LOGICAL_OPERATORS_REQUEST"] = "GET_LOGICAL_OPERATORS_REQUEST";
    PlannerPolicyActions["GET_LOGICAL_OPERATORS_SUCCESS"] = "GET_LOGICAL_OPERATORS_SUCCESS";
    PlannerPolicyActions["GET_LOGICAL_OPERATORS_FAIL"] = "GET_LOGICAL_OPERATORS_FAIL";
    PlannerPolicyActions["GET_DATE_TIME_DIAMETERS_REQUEST"] = "GET_DATE_TIME_DIAMETERS_REQUEST";
    PlannerPolicyActions["GET_DATE_TIME_DIAMETERS_SUCCESS"] = "GET_DATE_TIME_DIAMETERS_SUCCESS";
    PlannerPolicyActions["GET_DATE_TIME_DIAMETERS_FAIL"] = "GET_DATE_TIME_DIAMETERS_FAIL";
    PlannerPolicyActions["EVALUATE_PLANNER_POLICY_SUCCESS"] = "EVALUATE_PLANNER_POLICY_SUCCESS";
})(PlannerPolicyActions || (PlannerPolicyActions = {}));
function getAllPlannerPoliciesRequest() {
    return { type: PlannerPolicyActions.GET_ALL_PLANNER_POLICIES_REQUEST };
}
function getAllPlannerPoliciesSuccess(payload) {
    return { type: PlannerPolicyActions.GET_ALL_PLANNER_POLICIES_SUCCESS, payload };
}
function getAllPlannerPoliciesFail() {
    return { type: PlannerPolicyActions.GET_ALL_PLANNER_POLICIES_FAIL };
}
function createUpdatePlannerPolicySuccess(payload) {
    return { type: PlannerPolicyActions.CREATE_UPDATE_PLANNER_POLICY_SUCCESS, payload };
}
function deletePlannerPolicySuccess(payload) {
    return { type: PlannerPolicyActions.DELETE_PLANNER_POLICY_SUCCESS, payload };
}
export function getAllPlannerPolicies() {
    return (dispatch) => {
        dispatch(getAllPlannerPoliciesRequest());
        return wtsApi.v2.plannerPolicySearchCreate({ PageSize: -1 })
            .then(({ data }) => {
            dispatch(getAllPlannerPoliciesSuccess(data));
        })
            .catch((error) => {
            console.error(error);
            dispatch(getAllPlannerPoliciesFail());
            toastrError(error);
        });
    };
}
export function createUpdatePlannerPolicy(params) {
    return (dispatch) => {
        return wtsApi.v2.plannerPolicyCreateUpdateCreate(params)
            .then(({ data }) => {
            dispatch(createUpdatePlannerPolicySuccess(data.Data));
            toastr.success(I18n.t('PlannerPolicyUpdated'), '');
            return data;
        })
            .catch((error) => {
            console.error(error);
            toastrError(error);
            throw error;
        });
    };
}
export function deletePlannerPolicy(id) {
    return (dispatch) => {
        return wtsApi.v2.plannerPolicyDeleteDelete({ Id: id })
            .then(() => {
            dispatch(deletePlannerPolicySuccess(id));
            toastr.success(I18n.t('PlannerPolicyDeleted'), '');
        })
            .catch((error) => {
            console.error(error);
            toastrError(error);
            throw error;
        });
    };
}
function getAggregationOperationsRequest() {
    return { type: PlannerPolicyActions.GET_AGGREGATION_OPERATIONS_REQUEST };
}
function getAggregationOperationsSuccess(payload) {
    return { type: PlannerPolicyActions.GET_AGGREGATION_OPERATIONS_SUCCESS, payload };
}
function getAggregationOperationsFail() {
    return { type: PlannerPolicyActions.GET_AGGREGATION_OPERATIONS_FAIL };
}
function getAggregationTargetsRequest() {
    return { type: PlannerPolicyActions.GET_AGGREGATION_TARGETS_REQUEST };
}
function getAggregationTargetsSuccess(payload) {
    return { type: PlannerPolicyActions.GET_AGGREGATION_TARGETS_SUCCESS, payload };
}
function getAggregationTargetsFail() {
    return { type: PlannerPolicyActions.GET_AGGREGATION_TARGETS_FAIL };
}
function getLogicalOperatorsRequest() {
    return { type: PlannerPolicyActions.GET_LOGICAL_OPERATORS_REQUEST };
}
function getLogicalOperatorsSuccess(payload) {
    return { type: PlannerPolicyActions.GET_LOGICAL_OPERATORS_SUCCESS, payload };
}
function getLogicalOperatorsFail() {
    return { type: PlannerPolicyActions.GET_LOGICAL_OPERATORS_FAIL };
}
function getDateTimeDiametersRequest() {
    return { type: PlannerPolicyActions.GET_DATE_TIME_DIAMETERS_REQUEST };
}
function getDateTimeDiametersSuccess(payload) {
    return { type: PlannerPolicyActions.GET_DATE_TIME_DIAMETERS_SUCCESS, payload };
}
function getDateTimeDiametersFail() {
    return { type: PlannerPolicyActions.GET_DATE_TIME_DIAMETERS_FAIL };
}
export function getAggregationOperations() {
    return (dispatch) => {
        dispatch(getAggregationOperationsRequest());
        return wtsApi.v2.aggregationOperationSearchCreate({})
            .then(({ data }) => {
            dispatch(getAggregationOperationsSuccess(data));
        })
            .catch((error) => {
            console.error(error);
            dispatch(getAggregationOperationsFail());
            toastrError(error);
        });
    };
}
export function getAggregationTargets() {
    return (dispatch) => {
        dispatch(getAggregationTargetsRequest());
        return wtsApi.v2.aggregationTargetSearchCreate({})
            .then(({ data }) => {
            dispatch(getAggregationTargetsSuccess(data));
        })
            .catch((error) => {
            console.error(error);
            dispatch(getAggregationTargetsFail());
            toastrError(error);
        });
    };
}
export function getLogicalOperators() {
    return (dispatch) => {
        dispatch(getLogicalOperatorsRequest());
        return wtsApi.v2.logicalOperatorSearchCreate({})
            .then(({ data }) => {
            dispatch(getLogicalOperatorsSuccess(data));
        })
            .catch((error) => {
            console.error(error);
            dispatch(getLogicalOperatorsFail());
            toastrError(error);
        });
    };
}
// dtdiameter
export function getDateTimeDiameters() {
    return (dispatch) => {
        dispatch(getDateTimeDiametersRequest());
        return wtsApi.v2.dateTimeDiameterSearchCreate({})
            .then(({ data }) => {
            dispatch(getDateTimeDiametersSuccess(data));
        })
            .catch((error) => {
            dispatch(getDateTimeDiametersFail());
            toastrError(error);
        });
    };
}
export function evaluatePlannerPolicy(params) {
    return wtsApi.v2.plannerPolicyEvaluateCreate(params)
        .then(({ data }) => {
        return data.Data;
    })
        .catch((error) => {
        console.error(error);
        toastrError(error);
    });
}
